import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { TableBox, SearchFilter, Paging } from '../../components';
import { usePagination, useFilter } from '../../hooks';
import { SnackbarContext } from '../../contexts';
import Button from '@mui/material/Button';
import Handler from '../../Handler';
import API from '../../api';
import _ from 'lodash';

export const CsFaqListPage = (props) => {
  const history = useHistory();
  const { updateSnackbar } = useContext(SnackbarContext);
  const [list, setList] = useState(null);
  const [header, setHeader] = useState([
    {
      key: 'seq',
      align: 'center',
      text: 'No',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'site',
      align: 'center',
      text: '사이트',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return Handler.ENUM.CS.SITE(value);
      },
    },
    {
      key: 'category',
      align: 'center',
      text: '카테고리명',
      style: {
        minWidth: 200,
      },
    },
    {
      key: 'title',
      align: 'center',
      text: '제목',
      style: {
        minWidth: 200,
      },
      render: (value) => {
        return (
          <div style={{ maxWidth: 300 }} className='ellipsis-text'>
            <span>{value}</span>
          </div>
        );
      },
    },
    {
      key: 'createdAt',
      align: 'center',
      text: '등록일',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return Handler.getYYYYMMDDByUnix(value);
      },
    },
    {
      key: 'adminId',
      align: 'center',
      text: '작성자',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'view',
      align: 'center',
      text: '조회수',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return Handler.numberWithCommas(value);
      },
    },
  ]);

  const [filter, onFilterChange, setFiler] = useFilter([
    {
      key: 'site',
      type: 'select',
      label: '사이트 구분',
      value: 'SELECT_ALL',
      menus: [
        {
          value: 'SELECT_ALL',
          label: '전체',
        },
        {
          value: 'Credit',
          label: '인증시스템',
        },
        {
          value: 'Market',
          label: '마켓플레이스',
        },
      ],
    },
    {
      key: 'category',
      type: 'select',
      label: '카테고리',
      value: 'SELECT_ALL',
      menus: [
        {
          value: 'SELECT_ALL',
          label: '전체',
        },
      ],
    },
    {
      key: 'searchType',
      type: 'select',
      label: '검색 종류',
      value: 'Title',
      menus: [
        {
          value: 'Title',
          label: '제목',
        },
        {
          value: 'Content',
          label: '내용',
        },
      ],
    },
    {
      key: 'searchValue',
      type: 'input',
      label: '검색 값',
      value: '',
      inputType: 'text',
    },
  ]);
  const [page, totalPage, totalCount, onPageChange, setPage, setTotalPage, setTotalCount] = usePagination(0, 9);
  const [categoryInfo, setCategoryInfo] = useState(null);

  useEffect(() => {
    API.CS.GetFaqInfo().then(
      (res) => {
        console.log('GetFaqInfo res', res);
        let result = res.data;
        setCategoryInfo(result);
      },
      (err) => {
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      },
    );
  }, []);

  useEffect(() => {
    let current_site = filter[0].value;
    if (current_site && categoryInfo) {
      console.log('current_stie', current_site);

      let new_filter = _.clone(filter);
      let category_menus = Handler.buildCategoryMenus(categoryInfo, current_site, true);
      console.log('category_menus res', category_menus);
      new_filter[1].menus = category_menus;
      new_filter[1].value = category_menus[0].value;
      setFiler(new_filter);
    }
  }, [filter[0].value, categoryInfo]);

  useEffect(() => {
    console.log('page effect', page);
    requestNewList();
  }, [page]);

  const tableCallback = (type, index) => {
    console.log('tableCallback type', type);
    console.log('tableCallback index', index);
  };

  const tableRowClick = (index) => {
    console.log('tableRowClick index', index);
    let target_seq = list[index].seq;
    console.log('tableRowClick target_seq', target_seq);
    history.push('/cs/faq/detail/' + target_seq);
  };

  const onSearch = (body) => {
    console.log('onSearch', body);
    requestNewList(0);
  };

  const requestNewList = (init_page) => {
    let body = Handler.filterToBody(filter);
    console.log('page body', body);
    API.CS.GetFaqList({
      ...body,
      page: init_page ? init_page : page,
      size: Handler.VARIABLES.PAGE_LIMIT,
    }).then(
      (res) => {
        console.log('res', res);
        let result = res.data;
        setList(result.content);
        setTotalPage(result.totalPages);
      },
      (err) => {
        console.log('err', err);
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      },
    );
  };

  const requsetAdd = () => {
    console.log('requsetAdd');
    history.push('/cs/faq/add');
  };

  console.log('list', list);

  return (
    <article className='basic-page'>
      <section className='content-header__container'>
        <header>
          <h3>FAQ 목록</h3>
        </header>
        <div className='button__box'>
          <Button variant='contained' onClick={requsetAdd}>
            추가
          </Button>
        </div>
      </section>
      <section className='filter__container'>
        <SearchFilter data={filter} onChange={onFilterChange} onSearch={onSearch}></SearchFilter>
      </section>
      <section className='table__container'>
        <TableBox data={list} header={header} rowClick={tableRowClick} callback={tableCallback}></TableBox>
      </section>
      <section className='paging__container'>
        <Paging page={page} totalPage={totalPage} onChange={onPageChange}></Paging>
      </section>
    </article>
  );
};
